import type { SearchParameters } from "@/types/dto/search-filters/search-parameters";

const searchParamKeys = new Set<keyof SearchParameters>([
  "TourId",
  "keyword",
  "Continent",
  "Country",
  "Region",
  "City",
  "Duration",
  "PriceFrom",
  "PriceTo",
  "PriceRange",
  "Offers",
  "Badges",
  "TourStyles",
  "CustomerReview",
  "ActivityLevel",
  "months"
]);

export default searchParamKeys;
